/**
 * O cartão "Assistir Junto" do painel.
 *
 * Porte de `lib/features/watch_party/presentation/widgets/watch_party_card.dart`:
 * o cabeçalho com o selo de coração e o bilhete que abre a aba Juntos do
 * cinema. Não usa a `Secao` — o cartão do Flutter carrega o cabeçalho dele
 * próprio, e enfiar os dois dentro da moldura de seção daria dois títulos.
 *
 * O `Padding(horizontal: 24)` de lá não vem junto: aqui a folga lateral já é a
 * do `.palco`, como em todas as outras prévias do painel.
 */

import { Link } from 'react-router-dom';
import { Icone } from './Icone';
import { traduzir, usarDupla } from '@nosso-sempre/shared';
import './previas.css';

export function CartaoAssistirJunto() {
  // `AuthService.isCoupleUser`: a sessão guarda estado com dois donos, então
  // numa casa que não é de duas pessoas o cartão nem nasce.
  const { parceiro } = usarDupla();
  if (!parceiro) return null;

  return (
    <section aria-labelledby="assistir-junto" className="bloco previa-junto">
      <header className="previa-junto-topo">
        <span className="previa-junto-selo" aria-hidden="true">
          <Icone nome="coracao" tamanho={20} preenchido />
        </span>
        <div className="previa-junto-titulos">
          <div className="previa-junto-linha">
            <h2 id="assistir-junto" className="previa-junto-nome">
              {traduzir('Assistir Junto')}
            </h2>
            <span className="previa-junto-novo">
              <Icone nome="brilho" tamanho={10} />
              {traduzir('NOVO')}
            </span>
          </div>
          <p className="previa-junto-legenda">{traduzir('CINEMA EM TEMPO REAL')}</p>
        </div>
      </header>

      {/* `context.go('/cinema?tab=4')`: a aba Juntos, direto. */}
      <Link className="previa-junto-bilhete" to="/cinema?tab=4">
        <span className="previa-junto-fio-topo" aria-hidden="true" />
        <span className="previa-junto-clarao" aria-hidden="true" />

        <span className="previa-junto-icone" aria-hidden="true">
          <span className="previa-junto-disco" />
          <Icone nome="coracao" tamanho={28} preenchido />
          <span className="previa-junto-ponto" />
        </span>

        <span className="previa-junto-texto">
          <span className="previa-junto-chamada">
            <span className="previa-junto-abrir">{traduzir('Abrir o Assistir Junto')}</span>
            <span className="previa-junto-vivo">
              <span className="previa-junto-vivo-ponto" aria-hidden="true" />
              {traduzir('LIVE')}
            </span>
          </span>
          <span className="previa-junto-frase">
            {traduzir('Sessão de cinema em tempo real, dá play junto.')}
          </span>
          <span className="previa-junto-toque">
            <span className="previa-junto-toque-fio" aria-hidden="true" />
            {traduzir('TOQUE PARA ENTRAR NA SALA')}
          </span>
        </span>

        <span className="previa-junto-seta" aria-hidden="true">
          <Icone nome="adiante" tamanho={20} />
        </span>

        <span className="previa-junto-fio-base" aria-hidden="true" />
      </Link>
    </section>
  );
}
